






import 'reflect-metadata';
import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { InterdentalSpace as IInterdentalSpace } from '@/model/chart';

@Component
export default class InterdentalSpace extends Vue {
    @Model('checked') public readonly checked!: boolean;
    @Prop({ required: true, type: Object as () => IInterdentalSpace }) public space!: IInterdentalSpace;

    @Prop({ required: true }) private x!: number;
    @Prop({ required: true }) private y!: number;
    @Prop({ required: true }) private selectedColor!: string;

    get fillColor() {
        return this.checked ? this.selectedColor : 'lightGrey';
    }

    get selectedClass() {
        return this.checked ? 'selected' : '';
    }

    private onClick() {
        this.$emit('checked', !this.checked);
    }
}
